export const company = {
  RJRT: 'RJRT',
};
